// import { getItems } from './../../../services/stock/item'
import itemList from './itemList'
import itemSearch from './itemSearch'
import service from './../../../services/stock/item'
export default {
    namespaced: true,
    modules: {
        list: itemList,
        search: itemSearch
    },
    state: {
        list: []
    },
    getters: {
        list(state) {
            return state.list
        }
    },
    mutations: {
        set: (state, payload) => state.list = payload
    },
    actions: {
        // getAll(context) {
        //     return new Promise((resolve, reject) => {
        //         getItems()
        //             .then(response => {
        //                 context.commit("set", response.data);
        //                 resolve(response);
        //             })
        //             .catch(error => {
        //                 reject(error)
        //             });
        //     })
        // },
        create(context, payload) {
            return new Promise((resolve,reject) => {
                service.create(payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        },
        findByID(context, payload) {
            return new Promise((resolve, reject) => {
                service.findByID(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        update(context, payload) {
            return new Promise((resolve, reject) => {
                service.update(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        remove(context, payload) {
            return new Promise((resolve, reject) => {
                service.remove(payload).then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
    }
}